import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What tools are commonly used in Business Analytics?",
    category: "Technology",
    description:
      "Popular tools include Excel, SQL, Power BI, Tableau, Python, and R. These tools help clean data, perform analysis, visualize insights, and create dashboards that support business decisions.",
  },
  {
    title: "What job roles are available in Business Analytics?",
    category: "Trending",
    description:
      "Roles include Business Analyst, Data Analyst, BI Analyst, Reporting Analyst, Operations Analyst, Marketing Analyst, Product Analyst, and Insights Specialist. Each role focuses on analyzing data and supporting strategic business decisions.",
  },
  {
    title: "How is Business Analytics different from Data Analytics?",
    category: "Design",
    description:
      "Business Analytics focuses on deriving insights for business decisions and strategy, while Data Analytics emphasizes data exploration and technical analysis. Business Analytics is more decision-oriented, whereas Data Analytics is more technical.",
  },
  {
    title: "What is the role of visualization in Business Analytics?",
    category: "Design",
    description:
      "Visualization helps convert complex data into clear charts, graphs, and dashboards. Tools like Power BI and Tableau allow decision-makers to quickly understand trends, patterns, and insights.",
  },
  {
    title: "Can Business Analytics help companies increase revenue?",
    category: "Design",
    description:
      "Yes. Business Analytics identifies profitable opportunities, improves customer targeting, optimizes operations, reduces waste, and enhances marketing performance—directly contributing to higher revenue and better business outcomes.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
